import React from 'react'
import ReactDOM from 'react-dom'
import $ from 'jquery'
import { SCREENSMMIN } from '/js/variables/breakpoints'
import Location from './components/location'
import MarketsIndex from './components/markets-index'
import Error404 from './components/404'
import EventPageContent from './components/event-page-content'
import EventPageLoadingMessage from './components/events-single-loading-message'
import NortonBazaar from './components/location/location--norton'
import OTG_API from '/lib/otg-api'
var now = new Date()
var nextMonth = new Date()
nextMonth.setMonth( now.getMonth() + 2 )

OTG_API.getVendors()  // BUG: VendorsIndex doesn't work properly unless this request is finished first

switch ( MARKET_ID ) {
  /*
  Oct 2018 - use standard page setup for Winter Walk.
  This and related code can probably be removed if not used in winter 2019,
  or if major changes to location pages are made.
  */
  case 'emperor-nortons-holiday-bazaar':
  case 'salesforce-norton':
  case 'emperor-nortons-at-salesforce-transit-center':
    let north = OTG_API.getLocation( 'salesforce-norton' )
    let south = OTG_API.getLocation( 'emperor-nortons-at-salesforce-transit-center' )

    $.when( north, south )
    .done( ( north, south ) => {
      $('title').append( ' | ' + north.name )
      renderEventsLoading( north )

      $.when( north.fetchEvents(), south.fetchEvents() )
      .done( ()=>{
        if( Array.isArray(north.events) && north.events.length > 0 || Array.isArray(south.events) && south.events.length > 0 ){
          renderNortonBazaar( north, south )
        } else {
          var now = new Date()
          var later = new Date()
          later.setDate( now.getDate() + 90 )
          later.setHours( 0,0,0,0 )
          north.events = undefined
          south.events = undefined
          north.eventsDef = undefined
          south.eventsDef = undefined
          $.when(
            north.fetchEvents( { dateTo: later.getTime() } ), south.fetchEvents( { dateTo: later.getTime() } )
          )
          .done( ()=>{
            renderNortonBazaar( north, south )
          } )
        }
      } )
    } )
    .fail( () => {
      ReactDOM.render( <Error404 />, $('main')[0] )
    } )
  break;

  default:
    OTG_API.getLocation( MARKET_ID )
    .done( function( location ){
      $('title').append( ' | ' + location.name )
      renderEventsLoading( location )

      location.fetchEvents( { dateTo: nextMonth.getTime() } )
      .done( function(){

        var pageURL = window.location.href;
        var URLComponents = pageURL.split('/');

        URLComponents = URLComponents.filter( c => c.length > 1 )

        if ( URLComponents[URLComponents.length-1].startsWith('20') ) {
          history.replaceState({}, '', '../')

          if ( typeof EVENT_DATE == 'undefined') {

          var EVENT_DATE = URLComponents[URLComponents.length-1]
          }
        }

        if( typeof EVENT_DATE == 'string' && EVENT_DATE.length ){

          var eventDate = new Date( EVENT_DATE )
          var event = location.events.find( function( e ){ return e.startTime.getDateTime() == EVENT_DATE } )
        }

        if( ! event ) var event = location.events[0]

        renderWithEvent( event, location )
        renderBrowseMore( location )
      } )
      .fail( ()=>{
        ReactDOM.render( <Error404 />, $('main')[0] )
      } )
    } )
    .fail( function(){
      ReactDOM.render( <Error404 />, $('main')[0] )
    })
}

function renderEventsLoading(location) {
  let {name} = location;

  name = name.split(' ').includes('Emperor') ? 'Emperor Norton\'s Holiday Bazaar' : name;

  ReactDOM.render(<EventPageLoadingMessage event={name} />, $('#reactPageContent')[0] )
}
function renderBrowseMore( location ){
  ReactDOM.render(
    <div>
      <h2 className="highlight">Browse More Markets</h2>
      <MarketsIndex
        hideDistanceFilter={true}
        excludeMarket={ MARKET_ID }
        location={ { lat: location.latitude, lng: location.longitude } }
        initialPageLength={ window.innerWidth < SCREENSMMIN ? 3 : undefined }
      />
    </div>,
    $('.events')[0]
  )
}
function renderNortonBazaar( north, south ){
  ReactDOM.render(
    <NortonBazaar north={north} south={south} />,
    $('#reactPageContent')[0]
  )
}
let prevLocation
function renderWithEvent( event, location ){
  // subsequent calls may not pass a location argument
  if( typeof location === 'undefined' ){
    location = prevLocation
  } else {
    prevLocation = location
  }
  if( event ){
    event.fetchDetails()
    .done( ()=>{
      history.replaceState({}, '', event.startTime.getDateTime() )
      if( false && typeof LOCATION_EXTRAS !== 'undefined' ){
        /* These styles are not currently in use.
         * - Jonathan Denni, Jan 2019.

        ReactDOM.render(
          <Location
            event={ event }
            locationExtras={ LOCATION_EXTRAS }
            location={ location }
            setEvent={ renderWithEvent }
          />,
          $('#reactPageContent')[0]
        )
        */
      } else {
        ReactDOM.render(
          <EventPageContent
            event={ event }
            locationExtras={ typeof LOCATION_EXTRAS === 'undefined' ? undefined : LOCATION_EXTRAS }
            market={ location }
            setEvent={ renderWithEvent }
          />,
          $('#reactPageContent')[0]
        )
      }
    })
    .fail(()=>{
      ReactDOM.render( <Error404 />, $('main')[0] )
    })
  } else {
    ReactDOM.render(
      <Location
        location={ location }
        setEvent={ renderWithEvent }
      />,
      $('#reactPageContent')[0]
    )
  }
}
